"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebEvent = void 0;
/*
*/
var WebEvent = /*#__PURE__*/function (WebEvent) {
  WebEvent["PREFIX"] = "WSWEB__";
  WebEvent["SystemAction"] = "system-action";
  WebEvent["Update"] = "update";
  WebEvent["Notice"] = "notice";
  WebEvent["Notices"] = "notices";
  WebEvent["NoticeRead"] = "notice-read";
  WebEvent["NoticeOptions"] = "notice-options";
  WebEvent["NoticeOptionsUpdate"] = "notice-options-update";
  WebEvent["NoticeReceived"] = "notice-received";
  WebEvent["CalcNoticeUnreadCount"] = "calc-notice-unread-count";
  WebEvent["ChatMessage"] = "chat-message";
  WebEvent["ChatThread"] = "chat-thread";
  WebEvent["Reference"] = "reference";
  WebEvent["Verification"] = "verification";
  WebEvent["Schedule"] = "schedule";
  WebEvent["RedpointsUpdated"] = "redpoints-updated";
  WebEvent["BillingOperation"] = "billing-operation";
  WebEvent["Balance"] = "balance";
  WebEvent["Operation"] = "operation";
  WebEvent["Account"] = "account";
  WebEvent["Plan"] = "plan";
  WebEvent["WatchStart"] = "watch-start";
  WebEvent["WatchStop"] = "watch-stop";
  WebEvent["WatchStopAll"] = "watch-stop-all";
  WebEvent["Auth"] = "auth";
  WebEvent["AuthComplete"] = "auth-complete";
  return WebEvent;
}(WebEvent || (exports.WebEvent = WebEvent = {}));

